// 发货地址相关

import httpClient from "@/services/http/mainServerClient";

import ShippingAddressDTO, { ShippingAddressType } from "@/dto/ShippingAddressDTO";

/**
 * 列出所有当前用户所属店铺的所有发货地址
 * @param removeDeleted 部分业务场景需要显示删除的发货地址
 * @returns
 */
async function getList(removeDeleted = true, removeCasual = true): Promise<ShippingAddressDTO[]> {
    const shippingAddresses = await httpClient.get<ShippingAddressDTO[]>(`/shippingAddress`);

    const filteredShippingAddress: ShippingAddressDTO[] = [];

    shippingAddresses?.forEach((shippingAddress) => {
        if (removeDeleted && shippingAddress.deleted) {
            return;
        }

        if (removeCasual && shippingAddress.type === ShippingAddressType.CASUAL) {
            return;
        }

        filteredShippingAddress.push(shippingAddress);
    });

    return filteredShippingAddress;
}

// 创建一个新的发货地址
function create(params: Partial<ShippingAddressDTO>) {
    return httpClient.post(`/shippingAddress`, params);
}

// 更新发货地址
function update(params: Partial<ShippingAddressDTO>) {
    const { id } = params;
    return httpClient.post(`/shippingAddress/update/${id}`, params);
}

// 删除发货地址
function deleteShippingAddress(addressId: number) {
    return httpClient.post(`/shippingAddress/delete/${addressId}`);
}

// 发货地址绑定店铺
function bindShop({ addressId, shopIds }: any) {
    return httpClient.post(`/shippingAddress/${addressId}:bindShop`, {
        shopIds,
    });
}

// 解绑店铺
function unbindShop(addressId: any) {
    return httpClient.post(`/shippingAddress/${addressId}:unbindShop`);
}

// 更新发货地址的排序
function updateIndex({ addressId, index }: any) {
    return httpClient.post(`/shippingAddress/${addressId}:updateIndex`, {
        index,
    });
}

/** 通过发货地址id来恢复已被逻辑删除的发货地址 */
export function recoveryShippingAddress(id: number) {
    return httpClient.post(`/shippingAddress/recovery/${id}`, {
        id,
    });
}

export default {
    getList,
    create,
    update,
    delete: deleteShippingAddress,
    bindShop,
    unbindShop,
    updateIndex,
};

export { getList, create, update, deleteShippingAddress, bindShop, unbindShop, updateIndex };
